export const handleNameSlice = name => {
  if (!name) return [];
  if (name.length > 4) {
    return name.slice(0, 4).split('');
  }
  return name.slice(0, name.length).split('');
};
